import { Slider } from "@radix-ui/themes";
import { Flex, Text } from "@/components/display/display-primitives";
import {
  MAX_DURATION_SEC,
  MIN_DURATION_SEC,
  clampDurationSec,
} from "@/lib/display-timing-settings";

interface DisplayDurationSliderFieldProps {
  label: string;
  helpText: string;
  unitSingular: string;
  unitPlural: string;
  value: number;
  onChange: (value: number) => void;
}

export function DisplayDurationSliderField({
  label,
  helpText,
  unitSingular,
  unitPlural,
  value,
  onChange,
}: DisplayDurationSliderFieldProps) {
  const safeValue = clampDurationSec(value);
  const unit = safeValue <= 1 ? unitSingular : unitPlural;

  return (
    <Flex direction="column" gap="2">
      <Flex align="baseline" justify="between" gap="3">
        <Text as="label" size="2" style={{ color: "rgba(255,255,255,0.92)", fontWeight: 600 }}>
          {label}
        </Text>
        <Text size="2" style={{ color: "rgba(255,255,255,0.82)", fontWeight: 700 }}>
          {safeValue} {unit}
        </Text>
      </Flex>

      <Slider
        value={[safeValue]}
        min={MIN_DURATION_SEC}
        max={MAX_DURATION_SEC}
        step={1}
        onValueChange={(next) => {
          const n = next[0];
          if (typeof n === "number") {
            onChange(clampDurationSec(n));
          }
        }}
      />

      <Text size="1" style={{ color: "rgba(255,255,255,0.58)" }}>
        {helpText}
      </Text>
    </Flex>
  );
}
